export default function NamespaceManager() {
    let dataMap = new Map();
    return Object.defineProperties(
        {
            addNamespace(identifier, ns) {
                dataMap.set(identifier, ns);
            },
            removeNamespace(identifier) {
                dataMap.delete(identifier);
            },
            languageChangedCallback() {
                //callback after changed language loaded
            }
        },
        {
            nsArray: {
                get() {
                    return Array.from(dataMap.values())
                        .flat(1)
                        .filter(v => v);
                }
            },
            keys: {
                get() {
                    return Array.from(dataMap.keys());
                }
            }
        }
    );
}
